import { HeadSurprised } from "./HeadSurprised";
export default HeadSurprised;
